import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Search,
  FileText,
  Palette,
  User,
  LogOut,
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/scan', icon: Search, label: 'New Scan' },
  { to: '/reports', icon: FileText, label: 'Reports' },
  { to: '/branding', icon: Palette, label: 'Branding' },
  { to: '/account', icon: User, label: 'Account' },
];

export default function Sidebar() {
  const { user } = useAuth();

  return (
    <aside className="w-64 bg-void-lighter border-r border-teal/20 flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-teal/20">
        <h1 className="text-2xl font-tech font-bold text-teal">Velosent</h1>
        <p className="text-xs text-gray-500 mt-1">Sales Enablement Platform</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `nav-link ${isActive ? 'active' : ''}`
            }
          >
            <item.icon size={20} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* User info */}
      <div className="p-4 border-t border-teal/20">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-teal/20 flex items-center justify-center">
            <User size={20} className="text-teal" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium truncate">
              {user?.user.email || 'Loading...'}
            </p>
            <p className={`text-xs ${
              user?.user.subscription_status === 'active'
                ? 'text-signal-green'
                : 'text-signal-yellow'
            }`}>
              {user?.user.subscription_status === 'active' ? 'Pro Plan' : 'Inactive'}
            </p>
          </div>
        </div>
        <button className="nav-link w-full text-gray-500 hover:text-signal-red">
          <LogOut size={18} />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
}
